import * as _ from 'lodash';

export class CustomDictionary<T> {
    protected _values: { [key: string]: T } = {};

    public get(id: string): T {
        return this._values[id];
    }

    public addIfNotExists(id: string, value: T) {
        const currValue = this._values[id];
        if (!currValue) {
            this._values[id] = value;
        }
    }

    public addOrReplace(id: string, value: T) {
        this._values[id] = value;
    }

    public update(id: string, fieldsToUpdate: Partial<T>) {
        const value = this._values[id];
        if (value) {
            for (const key of Object.keys(fieldsToUpdate)) {
                const val = fieldsToUpdate[key];
                value[key] = val;
            }

            this._values[id] = value;
        }
    }

    public remove(id: string): boolean {
        const value = this._values[id];
        if (value) {
            delete this._values[id];
            return true;
        }
        return false;
    }

    public clear() {
        this._values = {};
    }

    public get values(): T[] {
        return Object.keys(this._values).map(key => this._values[key]);
    }

    public get keys(): string[] {
        return Object.keys(this._values);
    }
}

export class SelectedVehiclesDictionary extends CustomDictionary<string[]> {
    public get allValues(): string[] {
        return _.flatten(this.values);
    }
}
